import { createFileRoute } from '@tanstack/react-router'
import AlertHistoryPage from '@/components/pages/AlertHistoryPage/AlertHistoryPage'
import { z } from 'zod'

const alertHistorySearchSchema = z.object({
  page: z.number().optional(),
  environment: z.string().optional(),
  startDate: z.string().optional(),
  endDate: z.string().optional(),
  dismissed: z.string().optional(),
})

export const Route = createFileRoute('/$workspaceName/$environment/alert-history')({
  validateSearch: (search) => alertHistorySearchSchema.parse(search),
  component: AlertHistoryRoute,
})

function AlertHistoryRoute() {
  return <AlertHistoryPage />
}
